import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import {
  AddressSettingsPage,
  AiAgentSettingsPage,
  BasketSettingsPage,
  CatalogSettingsPage,
  CheckoutSettingsPage,
  ContentSettingsPage,
  CustomerSettingsPage,
  DeliverySettingsPage,
  EngagementSettingsPage,
  ChannelPreviewPage,
  MaxSettingsPage,
  InventorySettingsPage,
  MediaSettingsPage,
  NotificationSettingsPage,
  OrderSettingsPage,
  PaymentSettingsPage,
  PricingSettingsPage,
  SettingsIndexPage,
  TelegramBotMessagesPage,
  TelegramSettingsPage,
  TenantSettingsPage,
} from './ui/pages';
import { SettingsLayout } from './ui/SettingsLayout';

/**
 * Store-settings route subtree, mounted at `/settings` inside the app shell.
 *
 * Every screen renders inside {@link SettingsLayout} — a two-pane shell with a
 * grouped settings rail. The index renders a grouped, searchable overview; each
 * domain renders its own permission-gated screen. Unknown sub-paths fall back to
 * the overview.
 */
export const settingsRoutes: RouteObject = {
  path: 'settings',
  element: <SettingsLayout />,
  children: [
    { index: true, element: <SettingsIndexPage /> },
    { path: 'delivery', element: <DeliverySettingsPage /> },
    { path: 'payments', element: <PaymentSettingsPage /> },
    { path: 'checkout', element: <CheckoutSettingsPage /> },
    { path: 'orders', element: <OrderSettingsPage /> },
    { path: 'pricing', element: <PricingSettingsPage /> },
    { path: 'catalog', element: <CatalogSettingsPage /> },
    { path: 'customers', element: <CustomerSettingsPage /> },
    { path: 'notifications', element: <NotificationSettingsPage /> },
    { path: 'content', element: <ContentSettingsPage /> },
    { path: 'engagement', element: <EngagementSettingsPage /> },
    { path: 'telegram', element: <TelegramSettingsPage /> },
    { path: 'telegram/messages', element: <TelegramBotMessagesPage /> },
    { path: 'max', element: <MaxSettingsPage /> },
    { path: 'web', element: <ChannelPreviewPage channel="web" /> },
    { path: 'ozon', element: <ChannelPreviewPage channel="ozon" /> },
    { path: 'wildberries', element: <ChannelPreviewPage channel="wildberries" /> },
    { path: 'yandex-market', element: <ChannelPreviewPage channel="yandex-market" /> },
    { path: 'lamoda', element: <ChannelPreviewPage channel="lamoda" /> },
    { path: 'tenant', element: <TenantSettingsPage /> },
    { path: 'store', element: <Navigate to="/store" replace /> },
    { path: 'address', element: <AddressSettingsPage /> },
    { path: 'inventory', element: <InventorySettingsPage /> },
    { path: 'media', element: <MediaSettingsPage /> },
    { path: 'ai-agents', element: <AiAgentSettingsPage /> },
    { path: 'basket', element: <BasketSettingsPage /> },
    { path: '*', element: <Navigate to="/settings" replace /> },
  ],
};
